import CardWrapper from '../wrapper/card';
import EmailComponent from '../email';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { settingSelectedEmailAndSMSTab } from '../../redux/slices/deal';
import SMSComponent from '../sms';
import { a11yProps, CustomTabPanel } from '../../pages/deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, Tab, Tabs } from '@mui/material';
import { resettingEmailData, settingComposingFlagEmail, settingSelectedEmail } from '../../redux/slices/email';
import { resettingSMSData, settingComposingFlagSMS, settingSelectedSMS } from '../../redux/slices/sms';
import { useDispatch, useSelector } from 'react-redux';

const EmailAndSMSComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { flags } = useSelector((state: RootState) => state.deal);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        dispatch(settingSelectedEmail(null));
        dispatch(settingSelectedSMS(null));
        dispatch(settingComposingFlagEmail(false));
        dispatch(settingComposingFlagSMS(false));
        dispatch(settingSelectedEmailAndSMSTab(newValue === 0));
    };

    const navigateBackHandler = () => {
        dispatch(settingSelectedEmailAndSMSTab(null));
        dispatch(resettingEmailData());
        dispatch(resettingSMSData());
    };

    return (<Box padding="15px" minHeight="80vh" overflow="auto">
        {/*     <HeaderComponent /> */}
        <CardWrapper>
            <Button variant="text" color="secondary" startIcon={<KeyboardArrowLeft />} onClick={navigateBackHandler}>Back</Button>
            <Tabs
                value={flags?.showEmailAndSMS ? 0 : 1}
                onChange={handleChange}
                aria-label="deal details email and sms tabs"
            >
                <Tab
                    label="Email"
                    {...a11yProps(0)}
                />
                <Tab
                    label="SMS"
                    {...a11yProps(1)}
                />
            </Tabs>
            <Divider />
            <Box p={2}>
                <CustomTabPanel value={flags?.showEmailAndSMS ? 0 : 1} index={0}>
                    <EmailComponent />
                </CustomTabPanel>

                <CustomTabPanel value={flags?.showEmailAndSMS ? 0 : 1} index={1}>
                    <SMSComponent />
                </CustomTabPanel>
            </Box>
        </CardWrapper>
    </Box>);
};

export default EmailAndSMSComponent;